export default {
  'menu.login': "登入",
  'menu.auth': "身份驗證",
  'menu.home': "首頁",
  'menu.account': "帳戶",
  'menu.account.settings': '帳戶設定',
  'menu.ev_charger': "管理",
  'menu.ev_charger.ev_charger': "充電椿",
  'menu.ev_charger.device': "設備",
  'menu.ev_charger.device.create': '建立充電椿',
  'menu.ev_charger.device.info': '充電椿資料',
  'menu.ev_charger.schedule': "時間表",
  'menu.ev_charger.publicHoliday': '公眾假期',
  'menu.ev_charger.publicHolidayInfo': '公眾假期資料',
  'menu.ev_charger.publicHolidayCreate': '建立公眾假期',
  'menu.ev_charger.promotion': '推廣活動',
  'menu.ev_charger.location': "地點",
  'menu.user': "使用者管理",
  'menu.user.admin': "管理員",
  'menu.user.users': "後台用戶",
  'menu.user.createUsers': "新增後台用戶",
  'menu.user.appusers': "APP用戶",
  'menu.user.delappusers': "刪除APP用戶",
  'menu.user.userinfo': "用戶資料",
  'menu.advertising': "廣告管理",
  'menu.advertising.playlist.info': '廣告資料',
  'menu.advertising.playlist': "播放清單",
  'menu.advertising.playlist.create': '建立播放清單',
  'menu.advertising.mobile_adv': "手機廣告",
  'menu.advertising.mobile_adv.info': '手機廣告資料',
  'menu.advertising.mobile_adv.create': '新增手機廣告',
  'menu.advertising.document': "文件",
  'menu.advertising.document.upload': '上傳文件',
  'menu.transaction': "交易記錄",
  'menu.report': '報表',
  'menu.location': '地點',
  'menu.ev_charger.deviceInfo': '設備資料',
  'menu.ev_charger.deviceCreate': '建立設備',
  'menu.ev_charger.scheduleCreate': '建立時間表',
  'menu.ev_charger.scheduleInfo': '時間表資料',

};